import { render, staticRenderFns } from "./SettingFrame.vue?vue&type=template&id=b36b9344&scoped=true&"
import script from "./SettingFrame.vue?vue&type=script&lang=js&"
export * from "./SettingFrame.vue?vue&type=script&lang=js&"
import style0 from "./SettingFrame.vue?vue&type=style&index=0&id=b36b9344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36b9344",
  null
  
)

export default component.exports